import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CompareCtx = createContext(null);
const KEY = "dss_compare";
const MAX = 3;

export const compareGroup = (p) => (p.category === "mobiles" && ["5G Phones", "Budget Phones", "Flagship"].includes(p.subcategory) ? "phones" : p.category === "electronics" && p.subcategory === "Laptops" ? "laptops" : null);

export function CompareProvider({ children }) {
  const [items, setItems] = useState(() => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const has = (id) => items.some((p) => p.id === id);
  const toggle = (p) => {
    if (has(p.id)) return setItems(items.filter((x) => x.id !== p.id));
    const g = compareGroup(p);
    if (!g) return toast.error("Compare is available for phones and laptops");
    if (items.length && compareGroup(items[0]) !== g) return toast.error(`You can only compare ${compareGroup(items[0])} with ${compareGroup(items[0])}. Clear the list to switch.`);
    if (items.length >= MAX) return toast.error(`You can compare up to ${MAX} products`);
    setItems([...items, p]);
    toast.success("Added to compare");
  };
  const remove = (id) => setItems(items.filter((x) => x.id !== id));
  const clear = () => setItems([]);

  return <CompareCtx.Provider value={{ items, has, toggle, remove, clear }}>{children}</CompareCtx.Provider>;
}

export const useCompare = () => useContext(CompareCtx);
